import React, { Fragment } from 'react'
import { Button, Input } from '@driftt/tide-core'

import './style.css'

const ExtensionStep = ({ onDemoCTAClick, onContinueClick, profileHandle, userId }) => {
  return (
    <Fragment>
      <h1>Hooray! You&rsquo;re ready to get qualified meetings with Drift!</h1>
      <Input
          className="scheduling-link-input"
          label="Personal scheduling link"
          placeholder="John Doe"
          value={userId ? profileHandle : '...'}
          disabled={true}
          size="large"
        />
      <p>Share this personal scheduling link with your best leads so they can book meetings on your calendar.</p>
      <Button size="large" onClick={() => onDemoCTAClick()}>
        Try booking a meeting
      </Button>
      <span className="continue-to-dash" onClick={onContinueClick} >Continue to dashboard</span>
    </Fragment>
  )
}

export default ExtensionStep
